import { Address } from "./Address";
import { MedicalEducation } from './MedicalEducationModel';

export default class PhysicianCreation {
    constructor() {
        this.address = new Address();
        this.name = new PhysicianName();
        this.medicalEducation = new MedicalEducation();
    }
    name: PhysicianName;
    address: Address;
    medicalEducation: MedicalEducation;
    ssn4: string;
    email: string;
    dateOfBirth: string;
    examinationAppliedToId: number;
}

export class PhysicianName {
    firstName: string;
    lastName: string;
    middleName: string;
    suffix: string;
    title: string;
}